var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsNavCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down_small_fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.47133 9.69067C8.34632 9.81565 8.17678 9.88586 8 9.88586C7.82322 9.88586 7.65369 9.81565 7.52867 9.69067L5.64267 7.80467C5.54942 7.71139 5.48594 7.59255 5.46025 7.46319C5.43455 7.33383 5.44781 7.19975 5.49834 7.07792C5.54887 6.9561 5.6344 6.85199 5.74411 6.77879C5.85382 6.70558 5.98278 6.66656 6.11467 6.66667H9.88533C10.0172 6.66656 10.1462 6.70558 10.2559 6.77879C10.3656 6.85199 10.4511 6.9561 10.5017 7.07792C10.5522 7.19975 10.5654 7.33383 10.5398 7.46319C10.5141 7.59255 10.4506 7.71139 10.3573 7.80467L8.47133 9.69067Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0F4AA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNavCaret);
export default __webpack_public_path__ + "static/media/settings-nav-caret.39b49a31ae3677d89375f976ebd5fd6a.svg";
export { ForwardRef as ReactComponent };